// Dependencies
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { URL_SYNTAX, ENDPOINTS, AURORA } from '@/utils/endpoints/constants';
// Styling
import Icon from '@/components/common/Icon';

const Upload = () => {
  const { t } = useTranslation();

  // File upload state
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [folder, setFolder] = useState('allocations'); // Default folder

  // Handle file selection
  const handleFileChange = event => {
    setSelectedFile(event.target.files[0]);
  };

  // Handle folder selection
  const handleFolderChange = event => {
    setFolder(event.target.value);
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus(t('Please select a file first.'));
      return;
    }

    setUploading(true);
    setUploadStatus('');
    let url = ENDPOINTS.AURORA + URL_SYNTAX.SLASH + AURORA.UPLOAD;
    try {
      // Request a pre-signed URL from the backend
      const response = await axios.get(url, {
        params: { fileName: selectedFile.name, fileType: selectedFile.type, folder }
      });
      const { url: presignedUrl } = response.data;

      // Upload the file directly to S3 using the pre-signed URL
      await axios.put(presignedUrl, selectedFile, {
        headers: {
          'Content-Type': selectedFile.type
        }
      });
      console.log('Response: ' + response);
      let jsonResponse = JSON.stringify(response);
      console.log('Response JSON: ' + jsonResponse);
      setUploadStatus(t('File uploaded successfully!'));
    } catch (error) {
      console.error('Error uploading file:', error);
      setUploadStatus(t('Failed to upload file.'));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className='workspace-upload'>
      <div className='upload-icon'>
        <Icon name='download' size={24} />
      </div>
      <h2>Upload a spreadsheet</h2>
      <p>Choose the data you want to update, then select your file.</p>
      <label htmlFor='import-folder'>Data type</label>
      <select id='import-folder' value={folder} onChange={handleFolderChange} disabled={uploading}>
        <option value='allocations'>Allocations</option>
        <option value='professionals'>Professionals</option>
      </select>
      <label htmlFor='import-file' className='upload-dropzone'>
        <span>{selectedFile ? selectedFile.name : 'Select a spreadsheet'}</span>
        <small>Excel workbook (.xlsx)</small>
        <input id='import-file' type='file' accept='.xlsx' onChange={handleFileChange} disabled={uploading} />
      </label>
      <button className='workspace-button' onClick={handleUpload} disabled={uploading || !selectedFile}>
        {uploading ? 'Uploading…' : 'Upload file'}
      </button>
      {uploadStatus && <p role='status'>{uploadStatus}</p>}
    </div>
  );
};
export default Upload;
